import React from 'react';
import Icon from '@ant-design/icons';
import { Avatar, Col, Flex, Row } from 'antd';
import { DeleteRedBtn } from '../../assets/image/svg';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ICommentAll } from '../../types';
import { commentDelete } from '../../store/bids';

interface FormCommentProps {
  setOpenDrawerContainer?: (value: boolean) => void,
  dataRows?: any
}

const FormComment = ({ setOpenDrawerContainer, dataRows }: FormCommentProps) => {
  const dispatch = useDispatch();
  const dataCommentAll: ICommentAll[] = useSelector((state: RootState) => state.bids.dataCommentAll);

  const deleteComment = (id: number) => {
    dispatch(commentDelete({ id: id, bet_id: dataRows[0].id }));
  };

  const openFormNewComment = () => {
    if (setOpenDrawerContainer) {
      setOpenDrawerContainer(true);
    }
  };

  return (
    <>
      <Flex vertical>
        <Flex justify="space-between"  className={'header-bet_new'} align={'center'}>
          <div className={'fz-20'}>Просмотр</div>
        </Flex>
        <Flex className={'box__comment_title'}>
          <div className={'fz-16'}>Комментарии</div>
        </Flex>
      </Flex>
      <Flex gap={45} vertical className={'content__bet_comment'}>
        <Flex vertical gap={16} style={{ width: '95%' }}>
          {dataCommentAll?.map((comment, index) => (
            <React.Fragment key={index}>
              <Row gutter={[16, 14]}>
                <Col span={2}>
                  <Avatar size={32} src={comment.users?.avatar}>
                    {comment.users?.avatar ? comment.users?.avatar : dataCommentAll?.[0]?.users?.fio.slice(0, 2).toUpperCase()}
                  </Avatar>
                </Col>
                <Col span={18}>
                  <Flex gap={6} vertical>
                    <div className={'fz-14'}>{comment.users?.fio}</div>
                    <div className={'fz-12'}>{comment.text}</div>
                  </Flex>
                </Col>
                <Col span={4}>
                  <Flex gap={6} align={'center'}>
                    <div className={'text__date'}>{moment(comment.created_at).format('DD.MM.YYYY')}</div>
                    <Icon component={DeleteRedBtn} onClick={() => deleteComment(comment.id)} />
                  </Flex>
                </Col>
              </Row>
            </React.Fragment>
          ))}
        </Flex>
      </Flex>
    </>
  );
};

export default FormComment;
